import { useQuery } from "@tanstack/react-query";
import { LeaveBalance } from "../type";
import { getLeaveBalance } from "../api";

export const leaveBalanceKeys = {
  all: ["emp-leave-balance"] as const,
  list: (employeeId: number) =>
    [...leaveBalanceKeys.all, "list", employeeId] as const,
};

export function useLeaveBalance(employeeId: number) {
  return useQuery<LeaveBalance>({
    queryKey: leaveBalanceKeys.list(employeeId),
    queryFn: () => getLeaveBalance(employeeId),
    enabled: !!employeeId,
    staleTime: 60 * 60 * 1000,
    gcTime: 60 * 60 * 1000,
    retry: 3,
  });
}

